import React from "react";
import {Alert} from "antd";

interface DocumentLastSyncErrorProps {
    invalid: boolean;
    message: string;
}

export const DocumentLastSyncError: React.FC<DocumentLastSyncErrorProps> = ({invalid, message}) => {

    if (!invalid) {
        return null;
    }

    return (
        <Alert
            showIcon
            type="error"
            message={"Last sync ended with an error"}
            description={message || "Unknown error"}
        />
    );
}